<script>
import Orders from "./Orders/Index";
import PaymentHistory from "@/components/_Shared/PaymentHistory/Index";
import CantPayCycle from "@/components/_Shared/Checkout/CantPayCycle";

import { mapActions } from "vuex";
import cycleState from "@/utils/states/cycle";

export default {
  components: {
    Orders,
    PaymentHistory,
    CantPayCycle
  },
  data() {
    return {
      cycle: null
    };
  },
  methods: {
    ...mapActions("cycles", ["getCycle"]),
    async setCycle() {
      try {
        this.cycle = await this.getCycle(this.$route.params.id);
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao buscar o ciclo!");
      }
    },
    isInPaymentStatus() {
      return cycleState.isInPaymentStatus(this.cycle.status);
    },
    isAbleToPay() {
      return cycleState.isAbleToPay(this.cycle);
    }
  },
  mounted() {
    this.setCycle();
  }
};
</script>

<template>
  <div v-if="cycle" class="container">
    <orders :orders="cycle.orders" />

    <div class="card" v-if="!isAbleToPay()">
      <cant-pay-cycle :cycle="cycle" reason="day" />
    </div>

    <payment-history v-else :payments="cycle.payments">
      <template slot="header-right">
        <router-link
          v-if="isInPaymentStatus()"
          :to="{name: 'cycle-checkout', params: {cycle_id: cycle.id}}"
          class="btn-small btn bg-purple-outline btn-go-to-checkout"
        >Efetuar pagamento</router-link>
      </template>
    </payment-history>
  </div>
</template>

<style scoped>
.card {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Cycle/Index.vue